import axios from "axios";

const metricaApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/bloco-item-formulario`
})

async function servGetAllBlocoItem() {
    const response = await metricaApi.get('')
    return response.data
}

async function servGetBlocoAndItensByEstabelecimendoId(estabelecimentoId) {
    const response = await metricaApi.get('por-estabelecimendo',
        { params: { estabelecimentoId } }
    )
    return response.data
}

export {
    servGetAllBlocoItem,
    servGetBlocoAndItensByEstabelecimendoId
}